// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DisplayTime-module__start___eYd7r {
  display: flex;
  align-items: last baseline;
  gap: 4px;
  font-family: "Barlow Condensed", "IBM Plex Sans Condensed", "Arial Narrow", sans-serif;
  font-size: 39px;
  font-weight: 800;
  line-height: 1;
  letter-spacing: -0.01em;
  font-variant-numeric: tabular-nums;
  color: #18181b;
}

.DisplayTime-module__stack___dWlKH {
  display: flex;
  flex-direction: column;
  line-height: 19.5px;
}

.DisplayTime-module__meridiem___oZNDa {
  font-size: 15px;
  font-weight: 700;
  letter-spacing: 0.04em;
}

.DisplayTime-module__zone___y_v9r {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.04em;
  color: #71717a;
}

.DisplayTime-module__end___W1YLF {
  margin-top: 4px;
  font-family: "Barlow Condensed", "IBM Plex Sans Condensed", "Arial Narrow", sans-serif;
  font-size: 17px;
  font-weight: 700;
  line-height: 1;
  font-variant-numeric: tabular-nums;
  color: #71717a;
}

.DisplayTime-module__folded___ZryzR {
  align-items: baseline;
  font-size: 17px;
  font-weight: 700;
  letter-spacing: 0;
  white-space: nowrap;
  color: #71717a;
}
.DisplayTime-module__folded___ZryzR .DisplayTime-module__stack___dWlKH {
  flex-direction: row;
  align-items: baseline;
  gap: 3px;
  line-height: 1;
}
.DisplayTime-module__folded___ZryzR .DisplayTime-module__meridiem___oZNDa {
  font-size: inherit;
  letter-spacing: 0;
}
.DisplayTime-module__folded___ZryzR .DisplayTime-module__zone___y_v9r {
  font-size: 11px;
  letter-spacing: 0;
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/Visit/DisplayTime.module.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,0BAAA;EACA,QAAA;EACA,sFANQ;EAOR,eAAA;EACA,gBAAA;EACA,cAAA;EACA,uBAAA;EACA,kCAAA;EACA,cAAA;AADF;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AADF;;AAIA;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;AADF;;AAIA;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;AADF;;AAIA;EACE,eAAA;EACA,sFApCQ;EAqCR,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kCAAA;EACA,cAAA;AADF;;AAIA;EACE,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;AADF;AAGE;EACE,mBAAA;EACA,qBAAA;EACA,QAAA;EACA,cAAA;AADJ;AAIE;EACE,kBAAA;EACA,iBAAA;AAFJ;AAKE;EACE,eAAA;EACA,iBAAA;AAHJ","sourcesContent":["$display: 'Barlow Condensed', 'IBM Plex Sans Condensed', 'Arial Narrow', sans-serif;\n\n.start {\n  display: flex;\n  align-items: last baseline;\n  gap: 4px;\n  font-family: $display;\n  font-size: 39px;\n  font-weight: 800;\n  line-height: 1;\n  letter-spacing: -0.01em;\n  font-variant-numeric: tabular-nums;\n  color: #18181b;\n}\n\n.stack {\n  display: flex;\n  flex-direction: column;\n  line-height: 19.5px;\n}\n\n.meridiem {\n  font-size: 15px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n}\n\n.zone {\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  color: #71717a;\n}\n\n.end {\n  margin-top: 4px;\n  font-family: $display;\n  font-size: 17px;\n  font-weight: 700;\n  line-height: 1;\n  font-variant-numeric: tabular-nums;\n  color: #71717a;\n}\n\n.folded {\n  align-items: baseline;\n  font-size: 17px;\n  font-weight: 700;\n  letter-spacing: 0;\n  white-space: nowrap;\n  color: #71717a;\n\n  .stack {\n    flex-direction: row;\n    align-items: baseline;\n    gap: 3px;\n    line-height: 1;\n  }\n\n  .meridiem {\n    font-size: inherit;\n    letter-spacing: 0;\n  }\n\n  .zone {\n    font-size: 11px;\n    letter-spacing: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"start": `DisplayTime-module__start___eYd7r`,
	"stack": `DisplayTime-module__stack___dWlKH`,
	"meridiem": `DisplayTime-module__meridiem___oZNDa`,
	"zone": `DisplayTime-module__zone___y_v9r`,
	"end": `DisplayTime-module__end___W1YLF`,
	"folded": `DisplayTime-module__folded___ZryzR`
};
module.exports = ___CSS_LOADER_EXPORT___;
